import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth-guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'sign-in',
  },
  {
    path: 'sign-in',
    canActivate: [authGuard],
    loadComponent: () => import('./features/sign-in/pages/sign-in/sign-in').then((m) => m.SignIn),
  },
  {
    path: 'account-verified',
    loadComponent: () =>
      import('./features/sign-in/pages/account-verified/account-verified').then(
        (m) => m.AccountVerified,
      ),
  },
  {
    path: 'link-expired',
    loadComponent: () =>
      import('./features/sign-in/pages/link-expired/link-expired').then((m) => m.LinkExpired),
  },
  {
    path: 'already-used',
    loadComponent: () =>
      import('./features/sign-in/pages/already-used/already-used').then((m) => m.AlreadyUsed),
  },
  {
    path: 'sign-up',
    canActivate: [authGuard],
    loadComponent: () => import('./features/sign-up/pages/sign-up/sign-up').then((m) => m.SignUp),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/forgot-password/pages/forgot-password/forgot-password').then(
        (m) => m.ForgotPassword,
      ),
  },
  {
    path: 'app-content',
    loadComponent: () =>
      import('./features/app-content/pages/app-content/app-content.component').then(
        (m) => m.AppContentComponent,
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'main-admin',
      },
      {
        path: 'main-admin',
        loadComponent: () =>
          import('./features/main-admin/components/main-admin/main-admin').then((m) => m.MainAdmin),
      },
      {
        path: 'profile-account',
        loadComponent: () =>
          import('./features/profile-account/pages/profile-account/profile-account').then(
            (m) => m.ProfileAccount,
          ),
      },
      {
        path: 'main-installer',
        loadComponent: () =>
          import('./features/main-installer/components/main-installer/main-installer').then(
            (m) => m.MainInstaller,
          ),
      },
      {
        path: 'fleet-content',
        loadComponent: () =>
          import('./features/fleet-content/pages/fleet-content/fleet-content').then(
            (m) => m.FleetContent,
          ),
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'fleet-overview',
          },
          {
            path: 'fleet-overview',
            loadComponent: () =>
              import('./features/fleet-overview/components/fleet-overview/fleet-overview').then(
                (m) => m.FleetOverview,
              ),
          },
          {
            path: 'firmware-management',
            loadComponent: () =>
              import('./features/firmware-management/pages/firmware-management/firmware-management').then(
                (m) => m.FirmwareManagement,
              ),
          },

          {
            path: 'firmware-files',
            loadComponent: () =>
              import('./features/firmware-files/pages/firmware-files/firmware-files').then(
                (m) => m.FirmwareFiles,
              ),
          },
        ],
      },
      {
        path: 'shared-stove',
        loadComponent: () =>
          import('./features/shared-stove/components/shared-stove/shared-stove').then(
            (m) => m.SharedStove,
          ),
      },
      {
        path: 'user-management',
        loadComponent: () =>
          import('./features/user-management/pages/user-management/user-management').then(
            (m) => m.UserManagement,
          ),
      },
      {
        path: 'production',
        loadComponent: () =>
          import('./features/production/components/production/production').then(
            (m) => m.Production,
          ),
      },
      {
        path: 'stove-content/:stoveId',
        loadComponent: () =>
          import('./features/stove-content/pages/stove-content/stove-content').then(
            (m) => m.StoveContent,
          ),
        children: [
          {
            path: '',
            redirectTo: 'individual-stove',
            pathMatch: 'full',
          },
          {
            path: 'individual-stove',
            loadComponent: () =>
              import('./features/individual-stove/components/individual-stove/individual-stove').then(
                (m) => m.IndividualStove,
              ),
          },
          {
            path: 'graph',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./features/graph/components/graph/graph').then((m) => m.Graph),
              },
              {
                path: ':sessionId/details',
                loadComponent: () =>
                  import('./features/graph/components/details/details').then((m) => m.Details),
              },
            ],
          },
          {
            path: 'event-log',
            loadComponent: () =>
              import('./features/event-log/components/event-log/event-log').then((m) => m.EventLog),
          },
        ],
      },
    ],
  },
];
